// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Mq-z","imageAndVideoCount":"Nq-z","imageAndVideoContainer":"Oq-z","viewAllReviews":"Pq-z"};